import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ColorService {
  private fnv1aHash(str: string): number {
    let hash = 2166136261;
    for (let i = 0; i < str.length; i++) {
      hash ^= str.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0; // force unsigned
  }

  colorFromId(
    id: string,
    s = 100,
    l = 80,
  ): { h: number; s: number; l: number } {
    return {
      h: this.fnv1aHash(id) % 360,
      s,
      l,
    };
  }
}
